import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  return (
    <>
      <Navbar />

      <main className="pt-16">
        {/* Hero */}
        <section className="relative h-[280px] md:h-[350px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=elegant%20cinema%20theater%20interior%20with%20warm%20golden%20lighting%2C%20empty%20red%20velvet%20seats%2C%20grand%20movie%20screen%2C%20atmospheric%20mood%2C%20luxurious%20classic%20design%2C%20soft%20golden%20glow&width=1920&height=500&seq=yaya-about-hero&orientation=landscape"
              alt="关于丫丫影院"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/70"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-white/70 max-w-lg mx-auto">
              了解丫丫影院的故事与使命
            </p>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="w-full px-4 md:px-6 bg-background-50 border-b border-background-200">
          <Breadcrumb items={[{ label: '关于我们' }]} />
        </div>

        {/* Brand Introduction */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                丫丫影院 — 让观影更简单
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                丫丫影院成立于2024年，致力于为全球华语用户提供最新、最全的电影和电视剧在线资源。我们深知用户对观影体验的高要求——不缓冲、不卡顿、高清画质——这也是我们始终坚持的核心标准。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
              <div className="p-6 rounded-xl bg-background-100">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 mb-4">
                  <i className="ri-eye-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">我们的愿景</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  成为全球华语用户首选的影视在线平台，让每个人都能轻松享受高品质的观影体验。
                </p>
              </div>
              <div className="p-6 rounded-xl bg-background-100">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                  <i className="ri-flag-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">我们的使命</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  汇聚全球优质影视内容，以最快的更新速度和最流畅的播放体验服务每一位用户。
                </p>
              </div>
              <div className="p-6 rounded-xl bg-background-100">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 mb-4">
                  <i className="ri-heart-pulse-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">我们的价值观</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  用户至上、品质第一、持续创新。每一次播放体验都承载着我们对品质的承诺。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              <div>
                <p className="text-3xl md:text-4xl font-heading font-bold text-accent-500">500万+</p>
                <p className="text-sm text-foreground-500 mt-2">月活跃用户</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-heading font-bold text-primary-500">1000+</p>
                <p className="text-sm text-foreground-500 mt-2">影视资源</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-heading font-bold text-accent-500">99.7%</p>
                <p className="text-sm text-foreground-500 mt-2">用户满意度</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-heading font-bold text-primary-500">24h</p>
                <p className="text-sm text-foreground-500 mt-2">极速更新</p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-500">听听用户怎么说</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-6 rounded-xl bg-background-100">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-sm text-primary-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  &ldquo;丫丫影院真的不缓冲！之前用别的平台老是卡，换到这里之后追剧体验提升了不止一个档次。更新也很快，出资源第一时间就能看到。&rdquo;
                </p>
                <p className="text-xs text-foreground-500 font-medium">— 小王，资深追剧人</p>
              </div>
              <div className="p-6 rounded-xl bg-background-100">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-sm text-primary-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  &ldquo;画质确实好，而且完全免费。我最喜欢他们的分类功能，找电影特别方便。推荐给身边很多人了！&rdquo;
                </p>
                <p className="text-xs text-foreground-500 font-medium">— 小李，电影爱好者</p>
              </div>
              <div className="p-6 rounded-xl bg-background-100">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-sm text-primary-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  &ldquo;资源很全，想看的都有。而且不强制注册，点开就能看，这点太良心了。希望丫丫影院越做越好！&rdquo;
                </p>
                <p className="text-xs text-foreground-500 font-medium">— 小张，综艺达人</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500">如有任何问题或建议，欢迎联系我们</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-500">contact@yaya.tv</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                    <i className="ri-wechat-line text-accent-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">微信公众号</h3>
                    <p className="text-sm text-foreground-500">丫丫影院官方</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center shrink-0">
                    <i className="ri-weibo-line text-secondary-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">官方微博</h3>
                    <p className="text-sm text-foreground-500">@丫丫影院</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-time-line text-primary-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">工作时间</h3>
                    <p className="text-sm text-foreground-500">周一至周日 9:00 - 22:00</p>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="bg-background-50 rounded-xl p-6">
                <h3 className="text-base font-semibold text-foreground-950 mb-4">发送消息</h3>
                <form
                  id="about-contact-form"
                  data-readdy-form
                  action="https://readdy.ai/api/form/d9nh15e8mbnljin5a0ig"
                  method="POST"
                  encType="application/x-www-form-urlencoded"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const honeypot = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement);
                    if (honeypot && honeypot.value.trim() !== '') {
                      form.reset();
                      return;
                    }
                    try {
                      const formData = new FormData(form);
                      const res = await fetch(form.action, { method: 'POST', body: new URLSearchParams(formData as any).toString(), headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
                      const responseText = await res.text();
                      let parsed: any = {};
                      try { parsed = JSON.parse(responseText); } catch (_err) { /* ignore */ }
                      if (res.ok && parsed?.code === 'OK') {
                        form.reset();
                        alert('消息发送成功！');
                      } else {
                        alert('发送失败，请稍后重试');
                      }
                    } catch {
                      alert('网络异常，请稍后重试');
                    }
                  }}
                >
                  <input type="hidden" name="form_id" value="about-contact" />
                  <div className="space-y-4">
                    <div>
                      <input
                        type="text"
                        name="name"
                        placeholder="您的姓名"
                        className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <input
                        type="email"
                        name="email"
                        placeholder="您的邮箱"
                        className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <textarea
                        name="message"
                        placeholder="请输入您的留言..."
                        rows={4}
                        maxLength={500}
                        className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 transition-colors resize-none"
                        required
                      ></textarea>
                    </div>
                    <div className="honeypot-field">
                      <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                    </div>
                    <button
                      type="submit"
                      className="w-full py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      发送消息
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
              常见问题
            </h2>
            <div className="space-y-3">
              <details className="group rounded-xl bg-background-100 p-5 cursor-pointer">
                <summary className="text-sm font-medium text-foreground-900 list-none flex items-center justify-between">
                  丫丫影院是免费的吗？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                </summary>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  是的，丫丫影院所有影视资源完全免费，无需注册、无需付费，打开即可在线观看。
                </p>
              </details>
              <details className="group rounded-xl bg-background-100 p-5 cursor-pointer">
                <summary className="text-sm font-medium text-foreground-900 list-none flex items-center justify-between">
                  为什么选择丫丫影院？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                </summary>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  丫丫影院提供最新最全的影视资源，更新快、不缓冲、高清画质，并且完全免费。我们的目标是为用户提供极致的在线观影体验。
                </p>
              </details>
              <details className="group rounded-xl bg-background-100 p-5 cursor-pointer">
                <summary className="text-sm font-medium text-foreground-900 list-none flex items-center justify-between">
                  如何联系丫丫影院？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                </summary>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  您可以通过邮箱 contact@yaya.tv、微信公众号「丫丫影院官方」或官方微博 @丫丫影院 与我们取得联系。我们的工作时间是周一至周日 9:00-22:00。
                </p>
              </details>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于丫丫影院',
            description: '丫丫影院成立于2024年，致力于为全球华语用户提供最新、最全的电影和电视剧在线资源。',
            url: 'https://yaya.tv/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '丫丫影院',
              url: 'https://yaya.tv/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://yaya.tv/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '关于我们',
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '丫丫影院是免费的吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，丫丫影院所有影视资源完全免费，无需注册、无需付费，打开即可在线观看。',
                },
              },
              {
                '@type': 'Question',
                name: '为什么选择丫丫影院？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '丫丫影院提供最新最全的影视资源，更新快、不缓冲、高清画质，并且完全免费。',
                },
              },
              {
                '@type': 'Question',
                name: '如何联系丫丫影院？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过邮箱、微信公众号或官方微博与我们取得联系。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}